export class LopHocNienHoc {
    id : number;
    classCode : string;
    className : string;  
    schoolId : number;
    courseId : number; 
    schoolLevelId : number;
    schoolName : string;
    quantity : number;
    rule : string;
    managerId : number;

}